import { render, staticRenderFns } from "./CreateAddressbook.vue?vue&type=template&id=264e4dd2&"
import script from "./CreateAddressbook.vue?vue&type=script&lang=js&"
export * from "./CreateAddressbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports